import { Check } from "lucide-react";

export const TagPicker = ({ label, tags, selected, onToggle, testidPrefix = "tag" }) => (
  <div className="block">
    <span className="overline text-[#8A8A82]">{label}</span>
    <div className="mt-3 flex flex-wrap gap-2.5">
      {tags.map((t) => {
        const on = selected.includes(t);
        return (
          <button
            key={t}
            type="button"
            data-testid={`${testidPrefix}-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            onClick={() => onToggle(t)}
            aria-pressed={on}
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 font-grotesk text-[11px] uppercase tracking-[0.14em] border transition-all duration-300 ${
              on
                ? "border-[#B87333] bg-[#B87333]/15 text-[#F5F5F0]"
                : "border-white/15 text-[#C9C9C2] hover:border-white/35"
            }`}
          >
            {on && <Check size={13} className="text-[#B87333]" />}
            {t}
          </button>
        );
      })}
    </div>
  </div>
);
